import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { theme } from "../theme/theme";
import { Balance } from "../types";
import { toCurrency } from "../utils/currency";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getCurrencyUnit } from "../utils/utilities";

interface DailySummaryCardProps {
  title: string;
  value: string;
  color: string;
}

const DailySummaryCard = ({ title, value, color }: DailySummaryCardProps) => {
  const { userInfo } = useSelector((state: RootState) => state.app);
  return (
    <Card
      sx={{
        bgcolor: (theme) => theme.palette.grey[100],
        color: color,
        borderRadius: "8px",
        // height: "100%",
      }}
    >
      <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "0.2rem",
          }}
        >
          {/* <ArrowUpwardIcon /> */}
          <Typography
            gutterBottom
            // variant="h6"
            component="div"
            sx={{ fontWeight: "fontWeightRegular" }}
          >
            {title}
          </Typography>
        </Stack>
        <Typography
          variant="h6"
          sx={{
            wordBreak: "break-word",
            textAlign: "right",
            fontWeight: "fontWeightRegular",
          }}
        >
          {getCurrencyUnit(userInfo?.currency ?? "")}
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

interface DailySummaryProps {
  dailyBalance: Balance;
  // isMobile: boolean;
}

const DailySummary = ({ dailyBalance }: DailySummaryProps) => {
  const { isMobile } = useSelector((state: RootState) => state.app);
  const { t: tCommon } = useTranslation("common");
  // console.log(`dailyBalance:`, dailyBalance);
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={isMobile ? 4 : 6}>
          <DailySummaryCard
            title={tCommon("transaction.income")}
            value={toCurrency(dailyBalance.income || 0)}
            color={theme.palette.incomeColor.main}
          />
        </Grid>
        <Grid size={isMobile ? 4 : 6}>
          <DailySummaryCard
            title={tCommon("transaction.expense")}
            value={toCurrency(dailyBalance.expense || 0)}
            color={theme.palette.expenseColor.main}
          />
        </Grid>
        <Grid size={isMobile ? 4 : 12}>
          <DailySummaryCard
            title={tCommon("transaction.balance")}
            value={toCurrency(dailyBalance.balance || 0)}
            color={theme.palette.balanceColor.main}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DailySummary;
